import { FormikTextInput } from '@td-client-frontend/common';
import { TDHLogo } from '@td-client-frontend/icons';
import { Form, Formik, FormikHelpers } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { PiwikAction, PiwikCategory, PiwikName } from '../@types/common';
import { forgotPassword } from '../api/forgotPassword';
import { trackEvent } from '../api/piwik/piwikService';
import { Button } from '../components/form-controls/Button';

const ForgotPassword = () => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const history = useHistory();

  const handleSubmit = async (email: string) => {
    trackEvent({
      category: PiwikCategory.BUTTONS,
      action: PiwikAction.CLICKED,
      name: PiwikName.FORGOT_PASSWORD
    });

    await forgotPassword({ email }).catch(() => {});
  };

  return (
    <div className="flex flex-col justify-center w-full h-full max-w-md mx-auto font-effra" data-testid="fp-container">
      <Formik
        initialValues={
          {
            email: ''
          } as { email: string }
        }
        validationSchema={Yup.object({
          email: Yup.string().email('Invalid email address').required('Required')
        })}
        onSubmit={async (values, { setSubmitting }: FormikHelpers<{ email: string }>) => {
          setSubmitting(true);
          await handleSubmit(values.email);
          setHasSubmitted(true);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, isValid, values }) => (
          <>
            <Form className="px-4 pt-6 pb-8 md:px-8">
              <div className="my-4">
                <TDHLogo title="HY Logo" />
              </div>
              <h2 className="mt-6" data-testid="titleText">
                Forgot Password
              </h2>
              <div className="flex-1 py-4">
                {hasSubmitted ? (
                  <p>
                    If <span className="font-bold text-primary-blue">{values.email}</span> matched an account we will
                    send an email with instructions to complete your password reset. Please check your spam folder if
                    you do not see an email.
                  </p>
                ) : (
                  <FormikTextInput
                    data-testid="email"
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="Please enter email address"
                  />
                )}
                <div className="flex flex-col my-8 space-y-4 md:space-y-4">
                  {hasSubmitted ? (
                    <Button disabled={isSubmitting} onClick={() => history.push('/')}>
                      Return to Login
                    </Button>
                  ) : (
                    <>
                      <Button data-testid="submitButton" disabled={isSubmitting || !isValid} type="submit">
                        Reset password
                      </Button>
                      <Button data-testid="cancelButton" kind="secondary" onClick={() => history.push('/')}>
                        Cancel
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
